import React from 'react'
import './instructions.less'
import { Input, Icon, Button, Form, DatePicker, Checkbox, message } from 'antd'
import request from '@/utils/request'
import moment from 'moment'
import axios from 'axios'
import{ setLocalStorage , getLocalStorage,removeLocalStorage} from '@/utils/LocalStorage'
class Instructions extends React.Component {
  state = {
    isAgree: false,
    dataObjContent:null
  }
  GetPerson() {
    if (this.state.isAgree == true) {
      this.props.history.push('/Main/Menu')
    } else {
      message.error('请先勾选同意条款按钮！')
    }
  }
  CheckChange = e => {
    this.setState({
      isAgree: e.target.checked
    })
  }
  componentWillMount() {
   //getOpenId this.getDataInfo()
  if( getLocalStorage('facilityMarking-local') && getLocalStorage('USER_TOKEN') && getLocalStorage('facilityMarking-local') != getLocalStorage('USER_TOKEN')){
    removeLocalStorage('USER_TOKEN')
    removeLocalStorage('SCMT-ADMIN-TOKEN')
    removeLocalStorage('code')
    removeLocalStorage('facilityMarking-local')
   
    window.location.href='http://piao.scstm.com/wx'
  }
    this.auth();
  // this.getDataInfo()
  }  
  getDataInfo(){
    var that = this
    request
    .get('/v1/news?code=2')
    .then(res => {
       console.log('res')
      const data = res
      console.log(data)
      this.setState({
        dataObjContent: data
      })
    })
  }

  getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
}

  GetUrlParame(parameName) {
    /// 获取地址栏指定参数的值
    /// <param name="parameName">参数名</param>
    // 获取url中跟在问号后面的部分
    var parames = window.location.search
    // 检测参数是否存在
    if (parames.indexOf(parameName) > -1) {
        var parameValue = ''
        parameValue = parames.substring(parames.indexOf(parameName), parames.length)
        // 检测后面是否还有参数
        if (parameValue.indexOf('&') > -1) {
            // 去除后面多余的参数, 得到最终 parameName=parameValue 形式的值
            parameValue = parameValue.substring(0, parameValue.indexOf('&'))
            // 去掉参数名, 得到最终纯值字符串
            parameValue = parameValue.replace(parameName + '=', '')
            return parameValue
        }
        return ''
    }
}
auth(){
    console.log("1233333333333" + !this.getQueryString("code"));
    if (!this.getQueryString("code") || this.getQueryString("code") ==undefined || this.getQueryString("code") =="undefined" ) {
    
      let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd139eca3ea0002db&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect`
      window.location.href = url;
  } else {
      //console.log('第二次进入且路径中存在code')
      console.log("进入授权信息",11111)
      localStorage.setItem('code', this.GetUrlParame("code"));
      //后台请求微信返回openiD成功跳转登录界面
      let params = { 'wxcode': localStorage.getItem('code') }
      var that = this
      request
      .get('/v1/LoginAuth?code='+localStorage.getItem('code'))
      .then(res => {
         console.log('res' )
        console.log(res)
         if(res.code ==0){
          localStorage.setItem('facilityMarking-local',res.userId);
          localStorage.setItem('USER_TOKEN',res.userId);
          localStorage.setItem('SCMT-ADMIN-TOKEN',res.data)
          localStorage.setItem('tourist_cookie_authentication',res.userId);
         }else{
           console.log("cow");
          window.location.href ="http://piao.scstm.com/wx";
         }
        
        that.getDataInfo()
      })
  }
}
  render() {
    const { isAgree,dataObjContent } = this.state
    return (
      <div className="instructions">
        <div className="instructions_name">用户协议及隐私条款</div>
        <div className="instructions_content" style={{marginBottom:'100px'}}>
        <div className="instructions_content_row" dangerouslySetInnerHTML={{__html:dataObjContent}}>
        </div>
        </div>
        <div className="instructions_footer">
          <div className="aggree">
            <Checkbox onChange={this.CheckChange} checked={isAgree}>
              同意条款
            </Checkbox>
          </div>
          <div
            className="instructions_footer_button"
            onClick={el => this.GetPerson()}
          >
            我已阅读，同意预约
          </div>
        </div>
      </div>
    )
  }
}
export default Instructions
